<script setup>
import { computed } from 'vue';

const props = defineProps({
  imgSource: { type: String },
  tag: { type: String },
  active: { type: Boolean },
});

const emit = defineEmits(['click']);

const postTags = computed(() => {
  // Split each word and return array with first letter capitalized
  if (!props.tag) return [];
  return props.tag
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1));
});

const tooltipText = computed(() => props.tag || '');

function handleClick(event) {
  emit('click', event);
}
</script>

<template>
  <v-tooltip location="right" :text="tooltipText || tag">
    <template #activator="{ props: tooltipProps }">
      <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
      <div
        v-bind="tooltipProps"
        class="flex flex-col items-center justify-center cursor-pointer hover:brightness-90 transition duration-150"
        @click="handleClick"
      >
        <img
          class="icon max-w-10"
          :src="`/icons/app_icons/${imgSource}`"
          alt=""
        >
        <p v-for="(postTag, index) in postTags" :key="index" class="button-tag">
          {{ postTag }}
        </p>
      </div>
    </template>
  </v-tooltip>
</template>

<style scoped>
/* Styles for each individual tool */

/* Hover styles for each individual tool */
.button-container:hover {
  filter: brightness(0.8);
  transition: 0.15s;
}
</style>
